import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Root `/` is no longer a dashboard. Send the operator straight to the
 * bilty list, which is the home base of day-to-day work. The brand-mark
 * click in the header also lands here.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/bilty" });
  },
});
